import { Select, Space } from 'antd';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { BooleanSelectFilter } from '../../components/BooleanSelectFilter';

const DELIVERY_OPTIONS = [
  { label: 'Нова Пошта', value: 'nova_poshta' },
  { label: 'Укрпошта', value: 'ukrposhta' },
];

export const OrderFilters: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const deliveryValue = searchParams.get('deliveryProvider') ?? undefined;

  const handleChange = (name: string) => (value: string | undefined) => {
    setSearchParams((prev) => {
      if (value !== undefined) {
        prev.set(name, value);
      } else {
        prev.delete(name);
      }
      return prev;
    });
  };

  return (
    <Space wrap>
      <BooleanSelectFilter name="isPaid" placeholder="Оплачено" />
      <BooleanSelectFilter name="isCashed" placeholder="Проведено через касу" />
      <Select
        placeholder="Доставка"
        allowClear
        style={{ width: 160 }}
        value={deliveryValue}
        onChange={handleChange('deliveryProvider')}
        options={DELIVERY_OPTIONS}
      />
    </Space>
  );
};
